import Joi from "joi";
import errorsResolver from "../schemeUtils";
import {contactTypes} from "../../helpers/data-constants";

const PHONE_LENGTH = 20;

const clientContactScheme = Joi.object({
    index: Joi.any(),
    active: Joi.bool(),
    contactType: Joi.string()
        .required()
        .valid(...contactTypes)
        .error(errorsResolver({
            required: `Тип контакта обязательное поле`,
            values: `Тип контакта обязательное поле`
        })),
    phone: Joi.string()
        .trim()
        .required()
        .max(PHONE_LENGTH)
        .pattern(new RegExp('^[0-9\\-+ ]{1,20}$'))
      .when('contactType', {
        is: "Мобильный", then: Joi.string().required().pattern(new RegExp('^(\\+375 \\d{2} \\d{3} \\d{2} \\d{2})|(\\+375 __ ___ __ __)$'))
            .error(errorsResolver({
              pattern: 'Некорректно введен номер'
            }))
      })
        .error(errorsResolver({
            max: `Номер телефона должен быть длинной ${PHONE_LENGTH} символов`,
            required: `Номер телефона обязательное поле`,
            pattern: `Номер телефона содержит некорректные символы`
        })),
    email: Joi.string()
        .allow('')
        .email({ tlds: { allow: false } })
        .error(errorsResolver({
            email: `Почта имеет неправильный формат`
        }))
});


export default clientContactScheme;
